import URL_PARAMETERS from 'constants/url-parametrs';
import { useEffect } from 'react';
import getParamUrl from 'utils/get-param-url';

export default function useParamDetectionUrl() {
  useEffect(() => {
    URL_PARAMETERS.forEach((parameter) => {
      const param = getParamUrl(parameter);

      if (param) {
        if (parameter === 'gclid__c') {
          return localStorage.setItem('gclid', JSON.stringify({ value: param }));
        }
        return localStorage.setItem(parameter, JSON.stringify({ value: param }));
      }

      return null;
    });

    return null;
  }, []);
}
